import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/layout/Header";
import Footer from "@/components/landing/layout/Footer";
import { useGSAP } from "@/hooks/useGSAP";

import HowItWorks from "../components/HowItWorks";
import FAQSection from "../components/FAQSection";
import HeroSection from "../components/HeroSection";
import BrandSection from "../components/BrandSection";
import ValueSection from "../components/ValueSection";
import HowToBuy from "../components/HowToBuy";
import AccidentalDamageGrid from "../components/AccidentalDamageGrid";
import NotCovered from "../components/NotCovered";

const FaqData = [
  {
    question: "What does the Accidental Damage Protection Plan cover?",
    answer: "The Plan covers eligible accidental physical damage that affects the usability, functionality, or structural integrity of the covered product.",
  },
  {
    question: "How many claims are allowed ?",
    answer: "The Plan permits one (1) approved claim per covered product during the selected Plan term.",
  },
  {
    question: "Does the Plan cover airline baggage damage?",
    answer: "Yes. Subject to verification, airline baggage handling damage may be covered if the damage affects the functionality or structural integrity of the covered product.",
  },
  {
    question: "What happens if repair is not possible?",
    answer: "Protega may provide: Replacement or Store Credit (where applicable), Depending on the circumstances of the claim.",
  },
];

export default function EumeAccidental() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const lenis = new Lenis({
      duration: 1.6,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      smoothWheel: true,
      touchMultiplier: 2,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const handleBeforeUnload = () => {
      sessionStorage.setItem("scrollY", String(window.scrollY));
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 👇 Check if it's a reload (type === 'reload')
    const navEntries = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];
    const isReload = navEntries.length > 0 && navEntries[0].type === "reload";

    if (isReload) {
      const savedScrollY = sessionStorage.getItem("scrollY");
      if (savedScrollY !== null) {
        setTimeout(() => {
          window.scrollTo(0, parseFloat(savedScrollY));
        }, 100); // Wait for Lenis and DOM layout
      }
    }

    return () => {
      lenis.destroy();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useGSAP();

  return (
    <div className="tw-min-h-screen tw-bg-white tw-text-black">
      <Header />
      <main className="tw-relative">
        <div className="tw-h-20 lg:tw-h-24" />

        {/* hero section */}
        <HeroSection />

        {/* brand section */}
        <BrandSection />

        {/* accidental damage grid section */}
        <AccidentalDamageGrid />

        {/* value section */}
        <ValueSection />

        {/* how it works */}
        <HowItWorks />

        {/* not covered */}
        <NotCovered />

        {/* how to buy */}
        <HowToBuy />

        {/* faq section */}
        <FAQSection
          title="EUME Accidental Care Plan FAQs"
          data={FaqData}
          link="/eume/accidental/tnc"
        />

        {/* footer */}
        <Footer />
      </main>
    </div>
  );
}
